export const TUTORIAL_INTRO_PEOPLE = [
  { name: "Marie", image: "people_crops/marie/20231219_190139.webp" },
  { name: "James", image: "people_crops/james/20230823_101919.webp" },
];

export const AUSTRIA_INTRO_PEOPLE = [
  { name: "Marie", image: "people_crops/marie/20230822_130500.webp" },
  { name: "James", image: "people_crops/james/20230822_104539.webp" },
  { name: "Daniel", image: "people_crops/daniel/20230822_104539.webp" },
];

export const NORWAY_INTRO_PEOPLE = [
  { name: "Marie", image: "people_crops/marie/20240422_090319.webp" },
  { name: "James", image: "people_crops/james/20240425_100811.webp" },
];